export default __webpack_public_path__ + "7a72a3340ce85b059fc0c8072c851694.svg";